// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1-GPI","itemTitle":"ClientEmergencyInfo_itemTitle__BkeQo","itemText":"ClientEmergencyInfo_itemText__2ATGB"};